export const formDataFromObj = (obj) => {
  const formData = new FormData();
  const entries = Object.entries(obj);

  for (const [key, value] of entries) {
    if (value === null || value === undefined) {
      continue;
    } else if (value instanceof File) {
      formData.set(key, value, value.name);
    } else if (value instanceof Blob) {
      formData.set(key, value);
    } else if (value instanceof Array || value instanceof Object) {
      formData.set(key, JSON.stringify(value));
    } else {
      formData.set(key, value);
    }
  }

  return formData;
};
